/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconSms from './nav-icon-sms.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconSms {...validProps} />;
}
SvgComponent.iconName = 'navIconSms';

export const NavIconSmsIcon = svgIconWrapper(SvgComponent);
